<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="fullScreenDialog"
      persistent
      max-width="calc(50%)"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeFullScreenDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{$translate('DELIVERY_FEES_CONFIGURATOR')}}</v-toolbar-title>
        </v-toolbar>
        <v-list three-line style="max-width:80%;">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>{{$translate('STANDARD_DELIVERY_FEE')}}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{$translate('EXPL_STANDARD_DEL_FEE')}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
          <v-flex xs12>
            <v-layout row wrap>
              <v-container fluid grid-list-xl>
                <v-layout row wrap>
                  <v-flex xs1>
                    <v-checkbox
                      v-model="defaultDeliveryFee.Fallback"
                      color="primary"
                      class="checkboxWholeCountry"
                    />
                  </v-flex>
                  <v-flex xs7>
                    <p>{{$translate('DELIVERY_FEE_WHOLECOUNTRY')}}</p>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-text-field
                      v-model="defaultDeliveryFee.Price"
                      label="Price"/>
                  </v-flex>
                  <v-flex xs3>
                    <v-select
                      v-model="defaultDeliveryFee.VatId"
                      :items="vat"
                      item-text="Name"
                      required
                      label="VAT"
                      item-value="Name"
                    />
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="defaultDeliveryFee.MinimumOrderValue"
                      :label="$translate('MIN_ORDER_VALUE')"
                      type="number"
                      min="0"
                      required
                    />
                  </v-flex>
                  <v-flex xs3>
                    <v-spacer/>
                    <v-btn
                      round
                      color="primary"
                      @click="saveDeliveryFees"
                    >
                      {{$translate('SAVE')}}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-layout>
          </v-flex>
        <v-divider></v-divider>
        <div v-if="saveStandardFirst">
          <v-card class="pa-3" elevation-0></v-card>
        </div>
        <div v-else>
          <v-toolbar flat color="white">
              <v-list three-line style="max-width:90%;">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{$translate('ADDITIONAL_DELIVERY_FEE')}}</v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{$translate('EXPL_ADDITIONAL_DEL_FEE')}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            <v-divider
              class="mx-2"
              inset
              vertical
            ></v-divider>
            <v-dialog v-model="addAdditionalFeesDialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" round class="mb-2" v-on="on">{{$translate('NEW_DELIVERY_FEE')}}</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-model="editedItem.Name"
                          label="Name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-model="editedItem.Price"
                          label="Price"
                          type="number"
                          :disabled="!editedItem.DeliveryAllowed"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-model="editedItem.MinimumOrderValue"
                          :label="$translate('MIN_ORDER_VALUE')"
                          type="number"
                          min="0"
                          required
                          :disabled="!editedItem.DeliveryAllowed"
                        />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-checkbox
                          v-model="editedItem.DeliveryAllowed"
                          :label="$translate('DELIVERY_ALLOWED')"
                          color="primary"
                        />
                      </v-flex>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <h3> {{$translate('POSTAL_CODES')}}</h3>
                          <v-spacer></v-spacer>
                          <v-dialog v-model="addPostalCodeToDeliveryFeeDialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                              <v-flex xs12>
                                <v-spacer/>
                                <v-btn
                                  color="primary"
                                  round
                                  class="mb-2"
                                  v-on="on"
                                >{{$translate('POSTAL_CODE_RANGE')}}</v-btn>
                              </v-flex>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="headline">{{ formPostalCodeTitle }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-container grid-list-md>
                                  <v-layout wrap>
                                    <v-flex xs12>
                                      <p>{{$translate('ONLY_NUMBERS_ALLOWED')}}</p>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-text-field
                                        type="number"
                                        v-model="editedPostalCodeItem.MinPostalCode"
                                        label="Min postal code"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-text-field
                                        type="number"
                                        v-model="editedPostalCodeItem.MaxPostalCode"
                                        label="Max postal code"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        color="blue darken-1"
                                        flat
                                        @click="closePostalCodeToDeliveryFee"
                                        >Cancel
                                        </v-btn>
                                      <v-btn
                                        color="blue darken-1"
                                        flat
                                        @click="addPostalCode(editedPostalCodeItem.item)"
                                      >Save
                                      </v-btn>
                                    </v-card-actions>
                                  </v-layout>
                                </v-container>
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                      <v-data-table
                        :headers="postalCodeHeaders"
                        :items="editedItem.PostalCodes"
                        class="elevation-1 pa-2"
                      >
                        <template v-slot:items="props">
                          <td>{{ props.item.MinPostalCode }}</td>
                          <td class="text-xs-left">{{ props.item.MaxPostalCode }}</td>
                          <td class="justify-center layout px-0">
<!--                            <v-icon-->
<!--                              small-->
<!--                              class="mr-2"-->
<!--                              @click="editPostalCodeItem(props.item)"-->
<!--                            >-->
<!--                              edit-->
<!--                            </v-icon>-->
                            <v-icon
                              small
                              @click="deletePostalCodeItem(props.item)"
                            >
                              delete
                            </v-icon>
                          </td>
                        </template>
                      </v-data-table>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          flat
                          @click="close">
                          {{$translate('CANCEL')}}</v-btn>
                        <v-btn
                          color="blue darken-1"
                          flat
                          :disabled="editedItem.PostalCodes.length === 0"
                          @click="saveDeliveryFees"
                        >{{$translate('SAVE')}}</v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="eventDeliveryFees"
            class="elevation-1 pa-2"
          >
            <template v-slot:items="props">
              <td>{{ props.item.Name }}</td>
              <td class="text-xs-left">{{ props.item.Price }}</td>
              <td class="text-xs-left">{{ props.item.MinimumOrderValue }}</td>
              <td>
                <v-checkbox
                  v-model="props.item.DeliveryAllowed"
                  disabled
                  hide-details
                ></v-checkbox>
              </td>
              <td class="justify-center layout px-0">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(props.item)"
                >
                  edit
                </v-icon>
                <v-icon
                  small
                  @click="deleteItem(props.item)"
                >
                  delete
                </v-icon>
              </td>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import * as dssRequest from '@/api/dssRequest';

export default {
  name: 'DeliveryFeesDialog',
  props: {
    eventId: {
      type: Number,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      saveStandardFirst: false,
      // Additional fees postal codes
      addPostalCodeToDeliveryFeeDialog: false,
      editedPostalCodeIndex: -1,
      editedPostalCodeItem: {
        MinPostalCode: '',
        MaxPostalCode: '',
      },
      defaultPostalCodeItem: {
        MinPostalCode: '',
        MaxPostalCode: '',
      },
      // Additional fees dialog
      addAdditionalFeesDialog: false,
      editedIndex: -1,
      editedItem: {
        Id: '',
        Name: '',
        Price: '',
        MinimumOrderValue: 0,
        DeliveryAllowed: true,
        PostalCodes: [],
      },
      defaultItem: {
        Id: '',
        Name: '',
        Price: '',
        MinimumOrderValue: 0,
        DeliveryAllowed: true,
        PostalCodes: [],
      },
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'Name',
        },
        {
          text: 'Price',
          align: 'left',
          sortable: false,
          value: 'Price',
        },
        {
          text: this.$translate('MIN_ORDER_VALUE'),
          align: 'left',
          sortable: false,
          value: 'MinimumOrderValue',
        },
        {
          text: this.$translate('DELIVERY_ALLOWED'),
          align: 'left',
          sortable: false,
          value: 'DeliveryAllowed',
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'name',
          sortable: false,
        },
      ],
      postalCodeHeaders: [
        {
          text: 'MinPostalCode',
          align: 'left',
          sortable: false,
          value: 'MinPostalCode',
        },
        {
          text: 'MaxPostalCode',
          align: 'left',
          sortable: false,
          value: 'MaxPostalCode',
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'name',
          sortable: false,
        },
      ],

      eventDeliveryFees: [],
      defaultDeliveryFee: {},
      fullScreenDialog: true,
      notifications: false,
      sound: true,
      widgets: false,
      vat: [
        {
          Name: 'None',
        },
        {
          Name: 'Low',
        },
        {
          Name: 'High',
        },
      ],
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$translate('NEW_DELIVERY_FEE') : this.$translate('EDIT_DELIVERY_FEE');
    },
    formPostalCodeTitle() {
      return this.editedPostalCodeIndex === -1 ? this.$translate('NEW_POSTAL_CODE_RANGE') : this.$translate('EDIT_POSTAL_CODE_RANGE');
    },
  },
  watch: {
    addPostalCodeToDeliveryFeeDialog(val) {
      val || this.closePostalCodeToDeliveryFee();
    },
    addAdditionalFeesDialog(val) {
      val || this.close();
    },
  },
  created() {},
  mounted() {
    this.getDeliveryFees();
  },
  beforeDestroy() {},
  methods: {
    getDeliveryFees() {
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getDeliveryFees on - DeliveryFeesDialog.vue - was successful',
            response,
          );
          if (response.data.Standard.VatId === '') this.saveStandardFirst = true;
          this.defaultDeliveryFee = {};
          this.eventDeliveryFees = [];
          this.defaultDeliveryFee = response.data.Standard;
          this.eventDeliveryFees = response.data.DeliveryFees;
        },
        (error) => {
          console.log(
            'The generic call getDeliveryFees - DeliveryFeesDialog.vue - was not successful',
            error,
          );
        },
        'getDeliveryFees',
        this.eventId,
        payload,
      );
    },
    saveDeliveryFees() {
      if (this.addAdditionalFeesDialog) {
        console.log("Brian this.editedItem", this.editedItem, this.eventDeliveryFees);
        if (this.editedItem.Id === '') {
          if (this.editedItem.Price != null
          && this.editedItem.Price !== '') {
            this.editedItem.Price = Number(this.editedItem.Price);
          } else {
            this.editedItem.Price = 0;
          }

          if (this.editedItem.MinimumOrderValue != null
          && this.editedItem.MinimumOrderValue !== '') {
            this.editedItem.MinimumOrderValue = Number(this.editedItem.MinimumOrderValue);
          } else {
            this.editedItem.MinimumOrderValue = 0;
          }

          this.eventDeliveryFees.push(this.editedItem);
        } else {
          this.eventDeliveryFees.forEach((e) => {
            if (e.Id === this.editedItem.Id) {
              e.Name = this.editedItem.Name;
              e.PostalCodes = this.editedItem.PostalCodes;

              if (this.editedItem.Price != null
              && this.editedItem.Price !== '') {
                e.Price = Number(this.editedItem.Price);
              } else {
                e.Price = 0;
              }

              if (this.editedItem.MinimumOrderValue != null
              && this.editedItem.MinimumOrderValue !== '') {
                e.MinimumOrderValue = Number(this.editedItem.MinimumOrderValue);
              } else {
                e.MinimumOrderValue = 0;
              }

              e.DeliveryAllowed = this.editedItem.DeliveryAllowed;
            }
          });
        }
        this.close();
      }
      const payload = {
        Standard: this.defaultDeliveryFee,
        DeliveryFees: this.eventDeliveryFees,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call saveDeliveryFees on - DeliveryFeesDialog.vue - was successful',
            response,
          );
          this.getDeliveryFees();
        },
        (error) => {
          console.log(
            'The generic call saveDeliveryFees on - DeliveryFeesDialog.vue - was not successful',
            error,
          );
        },
        'saveDeliveryFees',
        this.eventId,
        payload,
      );
    },
    closeFullScreenDialog() {
      this.fullScreenDialog = false;
      this.$emit('turnDeliveryFeesDialogOff');
    },
    close() {
      this.addAdditionalFeesDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    closePostalCodeToDeliveryFee() {
      this.addPostalCodeToDeliveryFeeDialog = false;
      setTimeout(() => {
        this.editedPostalCodeItem = Object.assign({}, this.defaultPostalCodeItem);
        this.editedPostalCodeIndex = -1;
      }, 300);
    },
    editItem(item) {
      this.editedIndex = this.eventDeliveryFees.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.addAdditionalFeesDialog = true;
    },
    deleteItem(item) {
      const index = this.eventDeliveryFees.indexOf(item);
      confirm('Are you sure you want to delete this item?') && this.eventDeliveryFees.splice(index, 1);
      this.saveDeliveryFees();
    },
    editPostalCodeItem(item) {
      this.editedPostalCodeIndex = this.editedItem.PostalCodes.indexOf(item);
      this.editedPostalCodeItem = Object.assign({}, item);
      this.addPostalCodeToDeliveryFeeDialog = true;
    },
    deletePostalCodeItem(item) {
      const index = this.editedItem.PostalCodes.indexOf(item);
      confirm('Are you sure you want to delete this item?') && this.editedItem.PostalCodes.splice(index, 1);
    },
    addPostalCode() {
      this.editedItem.PostalCodes.push(this.editedPostalCodeItem);
      this.closePostalCodeToDeliveryFee();
    },
  },
};
</script>

<style lang='scss' scoped>
  .checkboxWholeCountry {
    margin-top: 0;
  }
</style>
